// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VzMVblvWRYkA9jlQ6CBU{justify-content:space-between;align-items:flex-start;padding:12px 1px 12px 0;display:flex}.CR56P1RzNZY5Jscg81gY{padding:4px 0}.q9brbbvhEsksHltQ51BB{border-radius:6px;height:4px}.sHcA5YC7RLEd21beBYEj{text-align:left}.UtEoeT8_rq00UU7zUziy{white-space:nowrap;padding-top:5px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"topLine": `VzMVblvWRYkA9jlQ6CBU`,
	"progressWrap": `CR56P1RzNZY5Jscg81gY`,
	"progressWrap__progress": `q9brbbvhEsksHltQ51BB`,
	"progressWrapProgress": `q9brbbvhEsksHltQ51BB`,
	"title": `sHcA5YC7RLEd21beBYEj`,
	"steps": `UtEoeT8_rq00UU7zUziy`
};
export default ___CSS_LOADER_EXPORT___;
